import { VersionedEntityOperationType, VersionedEntityType } from './versions';

enum ChatbotDataEntryType {
  QA = 'Q&A'
}

interface ChatbotDataEntryModel {
  // version & identity
  entityId?: string | null;
  versionType?: VersionedEntityType;
  operationType?: VersionedEntityOperationType;
  createdAt?: string;
  updatedAt?: string;

  // own fields
  type: ChatbotDataEntryType;
  question: string;
  answer: string;
  questionMessageId?: number | null;
  answerMessageId?: number | null;
}

interface ChatbotSettingsModel {
  botResponseThreshold: number;
  alarmPhrases: string[];
}

interface ChatbotTestRequestModel {
  id?: number;
  question?: string;
  answer?: string;
  rating?: number;
  chatbotFailedToReply?: boolean;
}

export { ChatbotDataEntryType };
export type { ChatbotDataEntryModel, ChatbotSettingsModel, ChatbotTestRequestModel };
